import { Injectable } from "@angular/core";
import { from, Observable, of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { IDamageAssessmentResponse } from "../../interfaces/i-damage-assessment-response";
import { ApiService, CoreMap } from "@vision/core-map-api";

@Injectable({
  providedIn: "root",
})
export class ElementsService {
  coreMap: CoreMap;

  /**
   * Get actual core map object
   * @returns {any}
   */
  getCoreMap(): any {
    return this.coreMap;
  }

  setCoreMap(coreMap: CoreMap) {
    this.coreMap = coreMap;
  }

  getApiService(): ApiService {
    return this.getCoreMap().getApiService();
  }

  requestDamageInformation(wkt: string, aoi: string = null): Observable<IDamageAssessmentResponse> {
    return from(this.getApiService().getPropertyDamage(wkt, aoi)).pipe(
      map((response) => {
        if (response instanceof Array) {
          return response[0];
        }
        console.log("Error requesting damage information");
        return {};
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  requestPropertyInformation(wkt: string, onDemand: boolean = false, type: string = null): Observable<any> {
    return from(this.getApiService().getPropertyInfo(wkt, onDemand, type)).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => err);
      }),
    );
  }

  requestPropertyStatus(id: string): Observable<any> {
    return from(this.getApiService().getPropertyStatus(id)).pipe(
      map((response) => response),
      catchError((err) => {
        return of(err);
      }),
    );
  }

  downloadPropertyInfo(id: string): Observable<any> {
    return from(this.getApiService().downloadPropertyInfo(id)).pipe(
      map((response) => response),
      catchError((err) => {
        return of(err);
      }),
    );
  }

  downloadPropertyReport(
    type: string,
    wkt: string,
    template: string,
    urban: string[],
    wide: string[],
    gray: string[],
    ir: string[],
    units: string,
  ): Observable<any> {
    return from(this.getApiService().downloadPropertyReport(type, wkt, template, urban, wide, gray, ir, units)).pipe(
      map((response) => response),
      catchError((err) => {
        return of(err);
      }),
    );
  }
}
